import styled from '@emotion/styled';
import { useState } from 'react';
import PropTypes from 'prop-types';
import CommentField from '@base/CommentField/CommentField';
import Divider from '@base/Divider/Divider';
import { toggleCommentLike, addReply } from '@actions/courses';
import { useDispatch, useSelector } from 'react-redux';
import CommentCard from './CommentCard';

const Container = styled.div`
  margin-top: 16px;
  margin-left: 48px;
`;

const Wrapper = styled.div`
  display: flex;
`;

const EmojiWrapper = styled.div`
  display: flex;
  padding: 8px 12px 8px 12px;
  border: 1px solid
    ${({ isLiked }) =>
      isLiked ? 'var(--color-i-green)' : 'var(--color-shadow)'};
  border-radius: 8px;
  background-color: ${({ isLiked }) =>
    isLiked ? 'rgba(8, 189, 128, 0.2)' : 'auto'};
  cursor: pointer;
  margin-right: 8px;
`;

const CommentWrapper = styled(EmojiWrapper)`
  background-color: ${({ selectedComment }) =>
    selectedComment ? 'var(--color-shadow)' : 'auto'};
  cursor: pointer;
`;

const Values = styled.span`
  color: ${({ isLiked }) =>
    isLiked ? 'var(--color-i-green)' : 'var(--color-text-primary)'};
  font-size: 12px;
  line-height: 150%;
  font-weight: 600;
`;

const UNDivider = styled(Divider)`
  margin-top: 16px;
  margin-bottom: ${({ $bottom }) => ($bottom ? '24px' : '16px')};
  background-color: var(--color-shadow);
  border-radius: 8px;
`;

const LikesAndReplies = ({ comment, storyId }) => {
  const dispatch = useDispatch();
  const username = useSelector(({ auth }) => auth.me.username.toLowerCase());
  const { upvoted, total_upvotes, comments, id, user } = comment;
  const updateLike = () => dispatch(toggleCommentLike(storyId, id, upvoted));

  let likes = 'Like';
  if (total_upvotes > 0) likes = `${total_upvotes} Like`;
  if (total_upvotes > 1) likes = `${total_upvotes} Likes`;
  let commentsNumber = 'Reply';
  if (comments.count > 0) commentsNumber = `${comments.count} Reply`;
  if (comments.count > 1) commentsNumber = `${comments.count} Replies`;

  const [selectedComment, setSelectedComment] = useState(null);
  const [value, setValue] = useState('');
  const onCommentClick = () => setSelectedComment(selectedComment ? null : id);

  const onChange = (e) => setValue(e.target.value);

  const addComment = () => {
    if (value === '') return;
    dispatch(addReply(storyId, id, value));
    setValue('');
  };

  const renderSelectedComments = () => {
    if (!selectedComment) return null;
    return (
      <>
        <UNDivider />
        <CommentField
          placeholder="Type your reply"
          onChange={onChange}
          value={value}
          onClick={addComment}
        />
        {comments.results.map((reply) => (
          <CommentCard key={reply.id} comment={reply} />
        ))}
        {comments.count > 0 && <UNDivider $bottom />}
      </>
    );
  };

  return (
    <>
      <CommentCard comment={comment} />
      <Container>
        <Wrapper>
          {username !== user.username.toLowerCase() && (
            <EmojiWrapper isLiked={upvoted} onClick={updateLike}>
              <Values isLiked={upvoted}>{likes}</Values>
            </EmojiWrapper>
          )}
          <CommentWrapper
            selectedComment={selectedComment === id}
            onClick={onCommentClick}
          >
            <Values>{commentsNumber}</Values>
          </CommentWrapper>
        </Wrapper>
        {renderSelectedComments()}
      </Container>
    </>
  );
};

export default LikesAndReplies;

LikesAndReplies.propTypes = {
  comment: PropTypes.objectOf(PropTypes.any).isRequired,
  storyId: PropTypes.string.isRequired
};
